import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { CloudApiService } from './services/cloud-api.service';

/**
 * `/location/:id` is a bare legacy route that renders a room without the dashboard's location tree
 * and tabs. Send it to the room's place in the dashboard (`/dashboard/:namespaceId/:locationId`),
 * keeping the query string (such as `?tab=`). When the tenant cannot be resolved the route renders
 * as before rather than losing the link.
 */
export const locationRedirectGuard: CanActivateFn = async (route) => {
    const api = inject(CloudApiService);
    const router = inject(Router);
    const id = route.paramMap.get('id');
    if (!id) return true;

    let namespaceId: string | null | undefined = api.locations()?.find((l) => l.id === id)?.appNamespaceId;
    if (!namespaceId) {
        try {
            namespaceId = (await api.getLocationDetails(id))?.appNamespaceId;
        } catch {
            namespaceId = null;
        }
    }
    if (!namespaceId) return true;
    return router.createUrlTree(['/dashboard', namespaceId, id], { queryParams: route.queryParams });
};
